import store from '../store'

export default (to, from, next) => {
  if (store.state.auth.isLoggedIn) {
    next()
  } else {
    next('/auth/login')
  }
}
